import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "spinner"]

  // 表单提交前立刻切换到 spinner 状态；等 turbo_stream 返回后整个 frame 被替换，spinner 自然消失
  submit() {
    if (this.hasContentTarget) {
      this.contentTarget.style.display = "none"
    }
    this.spinnerTarget.style.display = "flex"
  }
}
